// import request from '@/utils/request'
import axios from "axios";
import global from "@/global/variable.js";

// 获取车辆列表
export function getList(data) {
  const url = global.requestUrl + "/vehicle/getPage";
  return axios.post(url, data);
}
// 获取车牌号列表
export function getVehicleList(data) {
  const url = global.requestUrl + "/vehicle/list";
  return axios.post(url, data);
}

// 新增车辆信息
export function createVehicle(data) {
  const url = global.requestUrl + "/vehicle/save";
  return axios.post(url, data);
}

// 更新车辆信息
export function updateVehicle(data) {
  const url = global.requestUrl + "/vehicle/updateById";
  return axios.post(url, data);
}

// 删除车辆信息
export function deleteVehicle(data) {
  const url = global.requestUrl + "/vehicle/deleteBatch";
  return axios.post(url, data);
}
